// One definition of "are we being served from the platform (admin) host?", shared by the router
// (App.js), the boot effect and the first-run language default (AppContext.jsx). It used to be
// copied inline in all three, which is exactly how the boot effect came to run the CITIZEN
// sequence on the admin host — firing `/tenants` and `/cart`, which `AdminHostMiddleware`
// (web/middleware.py) refuses with a 404, and leaving the SPA on a broken citizen render.
//
// EXACT hostname match against the baked `REACT_APP_ADMIN_HOST` — no substring/suffix, mirroring
// the server's host check. This is UX hardening ONLY: the security boundary is the server's
// AdminHostMiddleware plus the `__session` cookie, never this. `process.env.REACT_APP_ADMIN_HOST`
// is inlined as a string literal at build time by CRA; reading it inside the function keeps the
// check testable (a test can set the env var and match jsdom's hostname) without changing runtime
// behaviour.
export function isAdminHost() {
  const adminHost = process.env.REACT_APP_ADMIN_HOST || "";
  return adminHost !== "" && window.location.hostname === adminHost;
}

// The public city site for `slug`, opened from the admin console (which serves only the console, so
// a relative `/<slug>` would land back on the admin host). The public app origin is baked in at
// build time as `REACT_APP_PUBLIC_APP_ORIGIN` — the deploy sets it to this environment's
// PUBLIC_BASE_URL (`https://apnashahar.online` in prod, the app-staging host in staging), the same
// per-environment value used for share/media links. We do NOT derive it by munging the admin
// hostname: that guessed at the deploy's naming and would break the moment a host didn't match.
// When the origin is unset (local dev, a single-host env, tests) there is no public site to point
// at, so this returns null and the caller hides the "View city site" link instead of guessing.
export function cityAppUrl(slug) {
  const origin = (process.env.REACT_APP_PUBLIC_APP_ORIGIN || "").replace(/\/+$/, "");
  return origin === "" ? null : `${origin}/${slug}`;
}
